// main.js
console.log('📦 Loading main.js...')

import Vue from 'vue'
import VueResource from 'vue-resource'
import KeenUI from 'keen-ui'
import AzureAD from '@/auth/index'
import App from './App.vue'
import router from './router'  // <- Stellen Sie sicher, dass dieser Import korrekt ist
import store from './store'
import AsyncComputed from 'vue-async-computed'
import '@mdi/font/css/materialdesignicons.css' // Material Design Icons lokal

console.log('🛣️ Router loaded:', !!router)

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(KeenUI)
Vue.use(AsyncComputed)

Vue.mixin({
    methods: {
        updateProgress(progress) {
            this.$store.commit('UPDATE_LOADING_PROGRESS', progress)
        }
    }
})

console.log('🔐 Setting up Azure AD...')

// MSAL nutzt sessionStorage + Cookies - funktioniert mit Tracking Prevention!
Vue.use(AzureAD, {
    instance: 'https://login.microsoftonline.com/',
    tenant: 'dgzfp.onmicrosoft.com',
    clientId: process.env.VUE_APP_AZUREAD_CLIENT_ID,
    redirectUri: process.env.VUE_APP_AZUREAD_REDIRECT_URL,
    postLogoutRedirectUri: window.location.origin,
    cacheLocation: 'sessionStorage', // Funktioniert auch mit Tracking Prevention
    groupFilterPrefix: 'taz-eq'
})

Vue.http.options.root = process.env.VUE_APP_API_ROOT

console.log('🔗 API Root URL:', process.env.VUE_APP_API_ROOT)
console.log('🔗 Vue HTTP Options:', Vue.http.options)
console.log('🚀 Creating Vue instance...')

// Keep MSAL tokens for F5 persistence - no cleanup needed
console.log('🔐 MSAL tokens preserved for F5 persistence')
console.log('📦 localStorage keys:', Object.keys(localStorage).filter(key => key.includes('msal')))

const vueInstance = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

console.log('✅ Vue instance created')
console.log('🔐 Azure AD available:', !!vueInstance.$azure)

window.app = vueInstance

export default vueInstance
